module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/tennessee-0a48a941cf62c52ca083ef3eae40d73e.svg";